import { get, post, put, del } from "../../httpClients/clients/http.client";
import {
  CountryDataResponse,
  CountryLocCodesResponse,
} from "@/dashboard-api-types/api/countryData.types";

const BASE_PATH = "/country";

export const CountryApi = {
  getLocCodes: (signal?: AbortSignal) =>
    get<CountryLocCodesResponse[]>(`${BASE_PATH}/`, { signal }),
  getByLocCode: (locCode: number, signal?: AbortSignal) =>
    get<CountryDataResponse>(`${BASE_PATH}/${locCode}`, { signal }),
};
